function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Mail"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M14.379 7.463a2 2 0 012.037-1.847l268.041 5.823a2 2 0 011.95 2.162l-12.196 149.236a1.999 1.999 0 01-1.727 1.819c-4.48.602-8.909.523-13.263-.12l-253.27-2.681a74.282 74.282 0 01-1.25-.014 1.998 1.998 0 01-1.955-2.152L14.379 7.463zm16.413 150.654l214.039 2.267c-11.899-5.058-22.953-13.666-32.595-23.073-15.222-14.851-27.354-32.124-34.233-41.918l-.886-1.261-29.096 21.335a2 2 0 01-2.403-.028l-26.086-20.091c-.581.868-1.353 1.9-2.289 3.064-1.915 2.379-4.58 5.381-7.875 8.772-6.59 6.783-15.756 15.184-26.58 23.346-14.85 11.198-32.994 22.074-51.996 27.587zm89.359-67.342l26.717 20.578 29.526-21.651 102.057-74.393L22.084 9.74l98.067 81.036zM18.073 11.615L6.898 157.85c25.963-.289 52.674-14.824 73.482-30.514 10.647-8.028 19.659-16.29 26.119-22.939 3.231-3.326 5.81-6.233 7.628-8.493.91-1.13 1.615-2.08 2.112-2.827l.147-.224-98.313-81.238zm263.992 6.01L180.347 91.77l.932 1.327c6.892 9.809 18.813 26.778 33.751 41.351 13.255 12.932 28.552 23.645 44.534 26.092l10.812.114 11.689-143.029z",
  className: "mailStroke",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M18 9l265 6-12 147-264.5-3L18 9z",
  className: "boxFill"
}));

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 290,
    height: 170,
    fill: "none",
    viewBox: "0 0 290 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.f3a4c2de.svg";
export { ForwardRef as ReactComponent };